/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "3db3321adba1de5da9556ddfec525641d6fb4740";
